import { MultiSelect, SelectOptionType } from "@aidkitorg/component-library";
import { useCallback, useMemo } from "react";
import { useLocalizedStrings } from "../../../../Localization";
import { FilterWrapper } from "./FilterWrapper";

interface StatusFilterProps {
  selectedStatuses: string[];
  availableStatuses: string[];
  onStatusesChange: (statuses: string[]) => void;
}

export const StatusFilter: React.FC<StatusFilterProps> = ({
  selectedStatuses,
  availableStatuses,
  onStatusesChange,
}) => {
  const L = useLocalizedStrings();

  const statusOptions = useMemo(() => {
    return availableStatuses.map(status => ({
      value: status,
      label: (L.admin_panel.invoices[`status_${status.toLowerCase().replace(' ', '_')}` as keyof typeof L.admin_panel.invoices] as string) || status,
    }));
  }, [availableStatuses, L]);

  const selectedStatusOptions = useMemo(() => {
    return statusOptions.filter(option => selectedStatuses.includes(option.value));
  }, [statusOptions, selectedStatuses]);

  const handleStatusesChange = useCallback((selectedOptions: SelectOptionType[]) => {
    const newStatuses = selectedOptions.map(option => option.value);
    onStatusesChange(newStatuses);
  }, [onStatusesChange]);

  return (
    <FilterWrapper label={L.admin_panel.invoices.filters.status}>
      <MultiSelect
        hideLabel
        label={L.admin_panel.invoices.filters.status}
        description={L.admin_panel.invoices.filters.select_status_description}
        options={statusOptions}
        value={selectedStatusOptions}
        onChange={handleStatusesChange}
        placeholder={L.admin_panel.invoices.filters.select_status_placeholder}
        searchable={true}
      />
    </FilterWrapper>
  );
};
